<template>
  <div :style="styles.base((!!getMedia) || (!getMedia && mediaLoaded))">
    <div :style="styles.loaderBackground" v-if="!mediaLoaded">
      <Spinner/>
    </div>
    <div :style="styles.mediaSidebar">
      <div :style="styles.nav">
        <button class="button" :style="styles.altNavButton" @click="goBack">
          <ChevronLeftIcon/>&nbsp;&nbsp;Back to All Media
        </button>
        <span :style="styles.separator"></span>
        <button
          class="button"
          :style="styles.saveButton(editsExist())"
          key="saveButton"
          @click="updateMedia(metadata)"
        >
          <ContentSaveIcon/>
          &nbsp;&nbsp;
          {{saveText}}
        </button>
        <!-- <button :style="styles.navButton" class="button">
          <ImageFilterNoneIcon/>
          &nbsp;&nbsp;
          Add {{getMedia.content_type}} to Action Card
        </button>-->
        <button class="button" :style="styles.navButton" @click="toggleUpdateThumbModal(true)">
          <ImageAreaIcon/>&nbsp;&nbsp;
          Change Thumbnail
        </button>
        <button
          class="button"
          :style="styles.deleteButton(canDelete)"
          :disabled="!canDelete"
          @click="() => canDelete ? promptDelete(getMedia._id) : false"
        >
          <DeleteIcon/>
        </button>
      </div>
      <div :style="styles.mediaContainer" v-if="getMedia">
        <div :style="styles.mediaThumbnailContainer">
          <div v-if="getMedia.createdAt" :style="styles.idWrapper">
            <p :style="styles.infoTitle">Uploaded:</p>
            <span :style="styles.createdStamp">{{formatDate(getMedia.createdAt)}}</span>
          </div>
          <div v-if="getMedia.guid" :style="styles.idWrapper">
            <p :style="styles.infoTitle">ID:</p>
            <span :style="styles.mediaId">{{getMedia.guid}}</span>
          </div>
          <div v-if="getMedia.mmId" :style="styles.idWrapper">
            <p :style="styles.infoTitle">MediaMobz ID:</p>
            <span :style="styles.mediaId">{{getMedia.mmId}}</span>
          </div>
          <div v-if="getMedia.contentType" :style="styles.idWrapper">
            <p :style="styles.infoTitle">Content Type:</p>
            <span :style="styles.p">{{getMedia.contentType}}</span>
          </div>
          <div v-if="getMedia.source">
            <p :style="styles.urlInformation">Original URL:</p>
            <input :value="getMedia.source" :style="styles.urlInput">
          </div>
          <div v-if="getMedia.thumbnail">
            <p :style="styles.urlInformation">Thumbnail URL:</p>
            <input :value="getMedia.thumbnail" :style="styles.urlInput">
          </div>
        </div>
        <div :style="styles.metadataContainer">
          <section :style="styles.metadataSection">
            <h4 :style="styles.metedataTitle">Title</h4>
            <input
              key="title-input-1"
              ref="title"
              @keyup="e => checkEdits('title', e.target.value)"
              v-model="title"
              :style="styles.metadataInput"
            >
          </section>
          <section :style="styles.metadataSection">
            <h4 :style="styles.metedataTitle">Description</h4>
            <textarea
              key="description-input-1"
              ref="description"
              @keyup="e => checkEdits('description', e.target.value)"
              v-model="description"
              :placeholder="(!metadata.description) ? '(no description)' : false"
              :style="styles.metadataInput"
              resize="auto"
              minHeight="200"
            />
          </section>
          <section :style="styles.metadataSection">
            <h4 :style="styles.metedataTitle">Keywords</h4>
            <textarea
              key="keywords-input-1"
              ref="keywords"
              @keyup="e => checkEdits('keywords', e.target.value)"
              v-model="keywords"
              :placeholder="(!keywords) ? '(no keywords)' : false"
              :style="styles.metadataInput"
              resize="auto"
              minHeight="200"
            />
          </section>
          <section :style="styles.metadataSection">
            <h4 :style="styles.metedataTitle">Product Groups</h4>
            <div :style="styles.checkBoxGroup">
              <label
                :key="group.name"
                :style="styles.checkBoxes"
                v-if="getAllProductGroups.length"
                v-for="(group, index) of getAllProductGroups"
              >
                <input
                  @change="checkBoxes('productGroups')"
                  type="checkbox"
                  v-model="productGroups"
                  :style="styles.checkBox"
                  :value="group._id"
                >
                {{group.title}}
              </label>
            </div>
          </section>
          <section :style="styles.metadataSection">
            <h4 :style="styles.metedataTitle">Media Libraries</h4>
            <div :style="styles.checkBoxGroup">
              <label
                :key="library.name"
                :style="styles.checkBoxes"
                v-if="getAllMediaLibraries.length"
                v-for="(library, index) of getAllMediaLibraries"
              >
                <input
                  type="checkbox"
                  @change="checkBoxes('mediaLibraries')"
                  v-model="mediaLibraries"
                  :style="styles.checkBox"
                  :value="library._id"
                >
                {{library.title}}
              </label>
            </div>
          </section>
        </div>
        <div :style="styles.marketsContainer" v-if="getMedia.markets && getMedia.markets.length">
            <section :style="styles.metadataSection">
            <label>
                <input
                    type="checkbox"
                    @change="e => checkEdits('featured', e.target.value)"
                    v-model="featured"
                    :style="styles.checkBox"
                > Featured
            </label>

          </section>
          <p :style="styles.urlInformation">Available In:</p>
          <p :style="styles.marketRef" v-for="market in getMedia.markets">
            <img :src="getFlagUrl(market)" :style="styles.flagStyles">
            {{ market.title }}
            <i
              @click="removeMediaFromMarket(market._id, getMedia._id)"
              class="glyphicon glyphicon-remove"
              :style="styles.removeMarket"
            />
          </p>
          <button
            v-if="!showAddMarket && listOtherMarkets.length"
            @click="toggleShowAddMarket"
            :style="styles.addMarketButton"
          >Add To Market</button>
          <select
            v-if="showAddMarket && listOtherMarkets.length"
            :style="styles.marketSelector"
            ref="selectedMarket"
            @change="addMediaToMarket"
          >
            <option disabled selected>Select market to add...</option>
            <option :value="market._id" v-for="market in listOtherMarkets">{{ market.title }}</option>
          </select>
          <button
            v-if="showAddMarket"
            @click="toggleShowAddMarket"
            :style="styles.addMarketButton"
          >Done</button>
        </div>
      </div>
      <img :style="styles.mediaThumbnail" :src="getMediaThumbnail">
    </div>
  </div>
</template>

<script>
import ChevronLeftIcon from 'vue-material-design-icons/ChevronLeft';
import ContentSaveIcon from 'vue-material-design-icons/ContentSave';
import DeleteIcon from 'vue-material-design-icons/Delete';
import ImageAreaIcon from 'vue-material-design-icons/ImageArea';
import ImageFilterNoneIcon from 'vue-material-design-icons/ImageFilterNone';
import Services from '../../services/Services';
import Spinner from '../general/Spinner';
import moment from 'moment';
import store from '../../store';
import VueNotifications from 'vue-notifications';
import { getResource, postResource } from '../../services/Utils.js';

export default {
  name: 'mediaTemplate',
  components: {
    DeleteIcon,
    ChevronLeftIcon,
    ContentSaveIcon,
    ImageFilterNoneIcon,
    ImageAreaIcon,
    Spinner
  },
  computed: {
    getMedia: {
      get: function() {
        return store.getters.getActiveMedia;
      },
      set: function(activeMedia) {
        store.commit('setActiveMedia', activeMedia);
      }
    },
    getMediaThumbnail: {
      get: function() {
        return store.getters.getActiveMedia.thumbnail;
      },
      set: function() {
        this.showSuccessMsg({
          message: `Thumbnail successfully updated.`
        });
      }
    },
    getAllProductGroups() {
      return store.getters.getAllProductGroups;
    },
    getAllMediaLibraries() {
      return store.getters.getAllMediaLibraries;
    },
    listOtherMarkets() {
      const markets = store.getters.getMarkets;
      const media = store.getters.getActiveMedia;
      console.log(media.markets);
      const other = markets.filter(
        m => !media.markets.map(ma => ma._id).includes(m._id)
      );
      return other;
    }
  },
  data() {
    return {
      toggleUpdateThumbModal: Services.toggleUpdateThumbModal,
      getFlagUrl: Services.getFlagUrl,
      canDelete: true,
      metadata: {},
      title: '',
      descriptionSaved: '',
      description: '',
      keywords: '',
      keywordsSaved: '',
      featured: false,
      featuredSaved: false,
      mediaLoaded: true,
      mediaLoading: false,
      productGroupsSaved: [],
      productGroups: [],
      mediaLibrariesSaved: [],
      mediaLibraries: [],
      mediaLoaded: true,
      showAddMarket: false,
      unsavedEdits: {
        description: false,
        title: false,
        productGroups: false,
        generalUses: false
      },
      saveText: 'Save Changes',
      styles: {
        base: active => ({
          opacity: active ? 1 : 0,
          pointerEvents: active ? 'auto' : 'none',
          flex: '0 0 auto',
          width: 'calc(100vw - 200px)',
          minHeight: '100vh',
          background: '#eee',
          display: 'flex',
          flexFlow: 'column nowrap',
          overflowY: 'auto',
          overflowX: 'hidden',
          padding: '70px 10px 10px'
        }),
        nav: {
          position: 'fixed',
          top: '0',
          left: '200px',
          right: '0',
          background: 'rgba(255,255,255,0.9)',
          borderBottom: '1px solid #eee',
          whiteSpace: 'nowrap',
          textOverflow: 'ellipsis',
          boxShadow: '0 0 20px 5px rgba(0,0,0,0.1)',
          height: '60px',
          zIndex: '99',
          padding: '10px',
          display: 'flex',
          flexFlow: 'row nowrap',
          alignItems: 'center',
          overflowX: 'auto',
          overflowY: 'hidden'
        },
        loaderBackground: {
          position: 'absolute',
          top: '0',
          left: '0',
          bottom: '0',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          right: '0',
          background: 'rgba(255,255,255,0.75)'
        },
        mediaSidebar: {
          overflowY: 'visible',
          flex: '0 0 auto'
        },
        navButton: {
          background: '#fff',
          border: '1px solid #09a3ed',
          fontSize: '0.9em',
          color: '#09a3ed',
          borderRadius: '5px',
          padding: '8px 12px',
          margin: 'auto 0 auto 10px',
          display: 'flex',
          flexFlow: 'row nowrap',
          alignItems: 'center',
          whiteSpace: 'nowrap',
          textOverflow: 'ellipsis',
          cursor: 'pointer'
        },
        altNavButton: {
          background: '#fff',
          border: '1px solid #aaa',
          fontSize: '0.9em',
          whiteSpace: 'nowrap',
          textOverflow: 'ellipsis',
          color: '#aaa',
          borderRadius: '5px',
          padding: '8px 12px',
          margin: 'auto 10px auto 0',
          display: 'flex',
          flexFlow: 'row nowrap',
          alignItems: 'center',
          cursor: 'pointer'
        },
        mediaContainer: {
          display: 'flex',
          flexFlow: 'row nowrap',
          width: '100%',
          flex: '1'
        },
        mediaThumbnailContainer: {
          flex: '1',
          padding: '0 10px 0 0'
        },
        mediaThumbnail: {
          flex: '0 0 auto',
          maxWidth: '100%',
          margin: '10px 5px 0 0'
        },
        marketRef: {
          padding: '10px',
          borderRadius: '5px',
          margin: '5px auto',
          boxShadow: '0 1px 4px 1px rgba(0,0,0,0.1)',
          background: '#fff',
          fontWeight: 400,
          fontSize: '0.9em',
          position: 'relative',
          display: 'flex',
          alignItems: 'center'
        },
        marketSelector: {
          padding: '10px',
          width: '100%',
          display: 'block',
          margin: '10px auto auto'
        },
        metadataContainer: {
          flex: '2',
          padding: '0'
        },
        marketsContainer: {
          flex: '1',
          padding: '0 0 0 10px'
        },
        metadataSection: {
          display: 'flex',
          flexFlow: 'column nowrap',
          padding: '15px',
          margin: '0 0 5px',
          borderBottom: '1px solid #eee',
          background: '#fff'
        },
        metedataTitle: {
          fontSize: '0.78em',
          margin: '0 0 5px',
          fontWeight: '700',
          textTransform: 'uppercase',
          color: '#aaa'
        },
        idWrapper: {
          background: '#fff',
          padding: '10px',
          display: 'flex',
          margin: '0 0 5px'
        },
        mediaId: {
          flex: '1',
          fontFamily: 'monospace',
          fontSize: '1em',
          fontWeight: '700',
          color: '#555',
          margin: 'auto auto auto 10px'
        },
        createdStamp: {
          flex: '1',
          fontSize: '0.8em',
          fontWeight: '700',
          color: '#555',
          margin: 'auto auto auto 10px'
        },
        flagStyles: {
          maxHeight: '24px',
          margin: 'auto 10px auto 0'
        },
        metadataInput: {
          border: '1px solid #aaa',
          padding: '10px',
          margin: '0',
          borderRadius: '5px',
          fontSize: '1.1em'
          // ':focus': {
          //   background: '#f5f5f5',
          //   padding: 10
          // }
        },
        clearButton: {
          background: '#ccc',
          color: '#888',
          margin: '10px auto 10px 0',
          padding: '10px',
          fontSize: '0.9em'
        },
        addInput: {
          borderRight: '0',
          borderLeft: '0',
          borderTop: '0',
          borderBottom: '1px solid #ddd',
          outline: 'none',
          padding: '5px'
        },
        actionIcon: {
          fontSize: '1.1em'
        },
        addMarketButton: {
          fontSize: '0.9em',
          color: '#888',
          borderRadius: '100px',
          padding: '5px 15px',
          margin: '10px auto',
          display: 'block',
          cursor: 'pointer',
          border: '1px solid #aaa',
          textAlign: 'center'
        },
        removeMarket: {
          position: 'absolute',
          right: '10px',
          top: '50%',
          transform: 'translateY(-50%)',
          fontSize: '1em',
          color: '#aaa',
          zIndex: 99999,
          cursor: 'pointer'
        },
        separator: {
          margin: '20px 0',
          borderTop: '1px solid #ccc'
        },
        deleteButton: canDelete => ({
          cursor: canDelete ? 'pointer' : 'no-drop',
          border: '1px solid #eb4d4b',
          background: '#fff',
          whiteSpace: 'nowrap',
          textOverflow: 'ellipsis',
          opacity: canDelete ? '1' : '0.3',
          pointerEvents: canDelete ? 'auto' : 'none',
          fontSize: '0.9em',
          color: '#eb4d4b',
          borderRadius: '5px',
          padding: '8px 9px',
          margin: 'auto 0 auto 10px',
          display: 'flex',
          flexFlow: 'row nowrap',
          alignItems: 'center',
          cursor: 'pointer'
        }),
        deleteMediaType: {
          textTransform: 'capitalize'
        },
        separator: {
          flex: 1
        },
        p: {
          lineHeight: '1.5px',
          color: '#444',
          margin: '8px 0 0',
          fontSize: '14px',
          fontWeight: '400',
          textTransform: 'capitalize'
        },
        infoTitle: {
          margin: '0px',
          textTransform: 'uppercase',
          color: '#888',
          fontSize: '0.8em',
          fontWeight: '700'
        },
        urlInformation: {
          margin: '0',
          textTransform: 'uppercase',
          color: '#888',
          padding: '10px 0 5px',
          fontSize: '0.8em',
          fontWeight: '700'
        },
        urlInput: {
          width: '100%',
          padding: '10px',
          borderRadius: '5px',
          border: '1px solid #ddd',
          color: '#09a3ed',
          fontSize: '0.9em',
          marginBottom: '10px'
        },
        previewThumbWrap: {
          display: 'flex',
          flexFlow: 'row nowrap',
          alignItems: 'flex-start'
        },
        backIcon: {
          fontSize: '1.2em'
        },
        checkBoxGroup: {
          display: 'flex',
          flexDirection: 'row',
          flexWrap: 'wrap'
        },
        checkBoxes: {
          fontWeight: 'normal',
          marginRight: '15px',
          minWidth: '95px'
        },
        checkBox: {
          marginRight: '5px'
        },
        topBar: {
          boxSizng: 'border-box',
          display: 'flex',
          justifyContent: 'space-between',
          padding: '10px',
          width: '100%'
        },
        editsWrapper: display => ({
          display: 'flex',
          flexDirection: 'row',
          flexWrap: 'no-wrap',
          opacity: display ? '1' : '0',
          transition: 'all 0.2s',
          transform: display ? 'translateY(0)' : 'translateY(20px)',
          width: '100%'
        }),
        saveButton: display => ({
          background: '#09a3ed',
          color: '#fff',
          borderRadius: '100px',
          whiteSpace: 'nowrap',
          textOverflow: 'ellipsis',
          width: '160px',
          flex: '0 0 auto',
          fontSize: '0.9em',
          opacity: display ? '1' : '0',
          padding: '9px 12px',
          margin: 'auto 0 auto 10px',
          pointerEvents: display ? 'inherit' : 'none',
          transform: display ? 'translateY(0)' : 'translateY(20px)',
          transition: 'all 0.2s',
          border: '0',
          ':hover': {
            opacity: '0.9'
          }
        })
      }
    };
  },
  methods: {
    setActiveMedia(media) {
      store.commit('setActiveMedia', media);
    },
    formatDate(date) {
      return (
        moment(date).format('M/D/YY hh:mma') + ` (${moment(date).fromNow()})`
      );
    },
    promptDelete(mediaId) {
      const shouldDelete = confirm(
        `Are you sure you want to permanently delete Media ${mediaId}?`
      );
      if (shouldDelete) return this.deleteMedia(mediaId);
    },
    deleteMedia(mediaId) {
      postResource(`/v1/media/delete?mediaId=${mediaId}`)
        .then(res => {
          this.showSuccessMsg({
            message: `Media successfully deleted.`
          });
          this.$router.push('/media');
        })
        .catch(err => {
          this.showErrorMsg({
            message: 'An error occurred. Please try again.'
          });
          console.log(err);
        });
    },
    setMediaProps(media) {
      // set saved values to component
      console.log('setting our props', media);
      this.title = media.title;
      this.titleSaved = media.title;
      this.description = media.description;
      this.descriptionSaved = media.description;
      this.productGroups = media.productGroups;
      this.productGroupsSaved = media.productGroups;
      this.mediaLibraries = media.mediaLibraries;
      this.mediaLibrariesSaved = media.mediaLibraries;
      this.keywords = media.keywords;
      this.keywordsSaved = media.keywords;
      this.featured = media.featured;
      this.featuredSaved = media.featured;
    },
    toggleShowAddMarket() {
      const b = this.showAddMarket;
      this.showAddMarket = !b;
    },
    goBack() {
      this.$router.push('/media');
    },
    editsExist() {
      return Object.keys(this.unsavedEdits).some(k => this.unsavedEdits[k]);
    },
    removeMediaFromMarket(marketId, mediaId) {
      postResource(
        '/v1/markets/media/remove',
        `marketId=${marketId}&mediaId=${mediaId}`
      )
        .then(res => {
          if (res.status === 'success') {
            this.showSuccessMsg({
              message: `Successfully removed media from market.`
            });
            Services.getMedia(this.$route.params.mediaId, media => {
              this.setMediaProps(this.getMedia);
            });
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    addMediaToMarket() {
      const mediaId = store.getters.getActiveMedia._id;
      console.log(mediaId);
      const marketId = this.$refs.selectedMarket.value;
      console.log(marketId);
      postResource(
        '/v1/markets/media/add',
        `marketId=${marketId}&mediaId=${mediaId}`
      )
        .then(res => {
          if (res.status === 'success') {
            this.showSuccessMsg({
              message: `Successfully added media to market.`
            });
            Services.getMedia(this.$route.params.mediaId, media => {
              this.setMediaProps(this.getMedia);
            });
          }
        })
        .catch(err => {
          console.log(err);
          this.showErrorMsg({
            message: 'An error occurred. Please try again.'
          });
        });
    },
    updateLibraries() {
      return new Promise((resolve, reject) => {
        const checkboxes = document.getElementsByName(
          'media_library_associations'
        );
        let checkboxesChecked = [];
        // loop over them all
        for (var i = 0; i < checkboxes.length; i++) {
          // And stick the checked ones onto an array...
          if (checkboxes[i].checked) {
            let checkedGroup = this.getAllMediaLibraries.find(
              group => group.id == checkboxes[i].value
            );
            checkboxesChecked.push(checkedGroup);
          }
        }

        this.mediaLibraries = checkboxesChecked;

        // check if we have added or removed anything
        let newGroups = checkboxesChecked.filter(
          o => !this.mediaLibrariesSaved.find(o2 => o.id === o2.id)
        );
        let removedGroups = this.mediaLibrariesSaved.filter(
          o => !checkboxesChecked.find(o2 => o.id === o2.id)
        );

        if (newGroups.length > 0 || removedGroups.length > 0) {
          const unsavedEdits = { ...this.unsavedEdits };
          unsavedEdits.mediaLibraries = true;

          this.unsavedEdits = unsavedEdits;
        } else {
          const unsavedEdits = { ...this.unsavedEdits };
          unsavedEdits.mediaLibraries = false;

          this.unsavedEdits = unsavedEdits;
        }
        resolve('updated');
      });
    },
    checkBoxes(section) {
      console.log('comparing libraries');
      let sectionSaved = `${section}Saved`;
      let equalSections =
        this[sectionSaved].every(e => this[section].includes(e)) &&
        this[section].every(e => this[sectionSaved].includes(e));

      console.log('equal libraries', equalSections);

      const unsavedEdits = { ...this.unsavedEdits };

      if (!equalSections) {
        unsavedEdits[section] = true;
      } else {
        unsavedEdits[section] = false;
      }

      this.unsavedEdits = unsavedEdits;
    },
    checkGroups(id) {
      if (this.productGroups.length) {
        return this.productGroups.find(group => group === id);
      }
    },
    checkEdits(section, string) {
      // Detect if they changed anything

      let originalSection = section + 'Saved';
      if (this[originalSection] != string) {
        console.log('editing subject');
        let unsavedEdits = { ...this.unsavedEdits };
        unsavedEdits[section] = true;

        this.unsavedEdits = unsavedEdits;
      } else {
        let unsavedEdits = { ...this.unsavedEdits };
        unsavedEdits[section] = false;

        this.unsavedEdits = unsavedEdits;
      }
    },
    updateMedia(media) {
      // insert setup here...
      const update = {
        title: this.title,
        description: this.description,
        productGroups: this.productGroups,
        mediaLibraries: this.mediaLibraries,
        keywords: this.keywords,
        featured: this.featured
      };

      // product groups we need to add the media to
      const addedProductGroups = [];

      if (
        this.productGroups.length &&
        !this.productGroups.every(e => this.productGroupsSaved.includes(e))
      ) {
        console.log('we have new product groups');
        // for each product group we added that is not in productsGroupSaved, push to addedProductGroups
        for (const i in this.productGroups) {
          let productGroup = this.productGroups[i];
          if (!this.productGroupsSaved.includes(productGroup)) {
            console.log('added product group', productGroup);
            addedProductGroups.push(productGroup);
          }
        }
      }

      if (addedProductGroups.length) {
        update.addedProductGroups = addedProductGroups;
      }

      const addedMediaLibraries = [];
      // media libraries we need to add the media to
      if (
        this.mediaLibraries.length &&
        !this.mediaLibraries.every(e => this.mediaLibrariesSaved.includes(e))
      ) {
        console.log('we have new media libraries');
        for (const i in this.mediaLibraries) {
          let mediaLibrary = this.mediaLibraries[i];
          if (!this.mediaLibrariesSaved.includes(mediaLibrary)) {
            console.log('added media library', mediaLibrary);
            addedMediaLibraries.push(mediaLibrary);
          }
        }
      }

      if (addedMediaLibraries.length) {
        update.addedMediaLibraries = addedMediaLibraries;
      }

      const removedProductGroups = [];
      // product groups we need to remove the media from
      if (
        this.productGroupsSaved.length &&
        !this.productGroupsSaved.every(e => this.productGroups.includes(e))
      ) {
        for (const i in this.productGroupsSaved) {
          let productGroup = this.productGroupsSaved[i];
          if (!this.productGroups.includes(productGroup)) {
            console.log('removed product group', productGroup);
            removedProductGroups.push(productGroup);
          }
        }
      }

      if (removedProductGroups.length) {
        update.removedProductGroups = removedProductGroups;
      }

      const removedMediaLibraries = [];
      // media libraries we need to remove the media from
      if (
        this.mediaLibrariesSaved.length &&
        !this.mediaLibrariesSaved.every(e => this.mediaLibraries.includes(e))
      ) {
        console.log('we have media libraries to remove');
        for (const i in this.mediaLibrariesSaved) {
          let mediaLibrary = this.mediaLibrariesSaved[i];
          if (!this.mediaLibraries.includes(mediaLibrary)) {
            console.log('removed media library', mediaLibrary);
            removedMediaLibraries.push(mediaLibrary);
          }
        }
      }

      if (removedMediaLibraries.length) {
        update.removedMediaLibraries = removedMediaLibraries;
      }

      console.log('our media update', update);

      postResource(
        `/v1/media/update?mediaId=${this.getMedia._id}`,
        false,
        update
      )
        .then(res => {
          this.saveText = 'Saved!';
          this.showSuccessMsg({
            message: `Media successfully saved!`
          });
          return res;
        })
        .then(res => {
          console.log('success', res);
          if (res.media) {
            this.setMediaProps(res.media);
          }
        })
        .then(() => {
          setTimeout(() => {
            this.unsavedEdits = {
              description: false,
              title: false,
              productGroups: false,
              generalUses: false
            };

            setTimeout(() => {
              this.saveText = 'Save';
            }, 500);
          }, 2250);
        })
        .catch(err => {
          console.log(err);
          this.showErrorMsg({
            message: 'An error occurred. Please try again.'
          });
        });
    }
  },
  mounted() {
    Services.getMedia(this.$route.params.mediaId, media => {
      if (!this.getMedia._id) {
        this.$router.push('/media');
      }
      this.setMediaProps(this.getMedia);
    });

    Services.getMarkets();
  },
  beforeDestroy() {
    this.description = '';
    this.title = '';

    Services.clearActiveMedia();
  },
  notifications: {
    showSuccessMsg: {
      type: VueNotifications.types.success,
      title: '',
      icon: '✅'
    },
    showErrorMsg: {
      type: VueNotifications.types.error,
      title: '',
      icon: '❗️'
    }
  }
};
</script>

<style lang="scss" scoped>
.button {
  align-items: center;
  background: #09a3ed;
  border-radius: 5px;
  border: 0;
  color: #fff;
  cursor: pointer;
  display: flex;
  flex-flow: row nowrap;
  font-size: 14px;
  font-weight: 700;
  justify-content: center;
  margin: 0 0 5px;
  outline: none;
  padding: 15px;
  transition: all 0.2s;

  &:hover {
    opacity: 0.9 !important;
  }
}

.metadataTitleId {
  display: inline-block;
  margin: auto 10px;
}

.metadataRow {
  flex-flow: row nowrap;
}
</style>



// WEBPACK FOOTER //
// src/components/views/MediaTemplate.vue